import React from "react";
import styled from "styled-components/macro";

const Mobile3x1Grid = styled.div(
  ({ theme: { space } }) => `
  display: grid;
  gap: ${space[1]}px;
  grid-template-columns: 1fr auto auto;
  grid-template-areas: "blank quick-search multi-button";  
  align-items: baseline;
`,
);

export function Mobile3x1Layout(props: {
  multiButton?: React.ReactNode;
  quickSearch?: React.ReactNode;
}) {
  const { multiButton, quickSearch } = props;
  return (
    <Mobile3x1Grid>
      <div />
      <div>{quickSearch || null}</div>
      <div>{multiButton || null}</div>
    </Mobile3x1Grid>
  );
}

const Mobile2x1Grid = styled.div(
  ({ theme: { space } }) => `
  display: grid;
  gap: ${space[1]}px;
  grid-template-columns: 1fr auto;
  grid-template-areas: "global-search-stretch multi-button";
  align-items: baseline;
`,
);

export function Mobile2x1Layout(props: {
  globalSearch?: React.ReactNode;
  multiButton?: React.ReactNode;
}) {
  const { globalSearch, multiButton } = props;
  return (
    <Mobile2x1Grid>
      <div>{globalSearch || null}</div>
      <div>{multiButton || null}</div>
    </Mobile2x1Grid>
  );
}

const Mobile2x2GridRow1 = styled.div(
  ({ theme: { space } }) => `
  display: grid;
  gap: ${space[1]}px;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: "round-filter blank multi-button";
  align-items: baseline;
`,
);

const Mobile2x2GridRow2 = styled.div(
  ({ theme: { space } }) => `
  display: grid;
  gap: ${space[1]}px;
  grid-template-columns: auto 1fr;
  grid-template-areas: "quick-search global-search-stretch";
  align-items: baseline;
`,
);

export const InnerGrid = styled.div(
  ({ theme: { space } }) => `
  display: grid;
  gap: ${space[1]}px;
  align-items: baseline;
  grid-auto-flow: column;
`,
);

export function Mobile2x2Layout(props: {
  globalSearch?: React.ReactNode;
  multiButton?: React.ReactNode;
  quickSearch?: React.ReactNode;
  roundFilter?: React.ReactNode;
}) {
  const { globalSearch, multiButton, quickSearch, roundFilter } = props;
  return (
    <>
      <Mobile2x2GridRow1>
        <InnerGrid>{roundFilter || null}</InnerGrid>
        <div />
        <InnerGrid>{multiButton || null}</InnerGrid>
      </Mobile2x2GridRow1>
      <Mobile2x2GridRow2>
        <InnerGrid>{quickSearch || null}</InnerGrid>
        <InnerGrid>{globalSearch || null}</InnerGrid>
      </Mobile2x2GridRow2>
    </>
  );
}
